import * as PIXI from "pixi.js";
import { Coord } from "../../../types/Interface";
import SwitcherButton from "../SwitcherButton/SwitcherButton";
import { BG_PADDING, CIRCLE_RADIUS, COLOR_BUTTON_STYLE, COLORS } from "./Constants";
import ColorCircle from "./ColorCircle";
import addInteractivity from "../../../utils/addInteractivity";
import { CustomCursorType } from "../CustomCursor/CustomCursor";


export default class ColorOptionConRenderer extends PIXI.Container {
  private buttons: SwitcherButton[] = [];
  public bg = this.addChild(new PIXI.Graphics());

  constructor(coord: Coord, width: number, private onHandle: (i) => void, private onHandleSec: () => void) {
    super();
    this.position.copyFrom(coord);
    this.drawBg(width);
    this.drawColorCircles(width);
  }
  public getButtons = () => this.buttons;
  private drawColorCircles(width: number) {

    const unit = width / COLORS.length;
    const sX = -width / 2;

    this.buttons = COLORS
      .map((c, cI) => {
        const _x = sX + unit * (cI + .5)
        const circle = new ColorCircle(c);
        COLOR_BUTTON_STYLE.x = _x;
        const button = new SwitcherButton(COLOR_BUTTON_STYLE, circle, false, () => this.onHandle(cI), () => this.onHandleSec())
        this.addChild(button);
        return button
      })
  }

  private drawBg(width: number) {
    const sX = -width / 2;
    this.bg
      .roundRect(sX, -CIRCLE_RADIUS - BG_PADDING, width, 2 * (CIRCLE_RADIUS + BG_PADDING), 6)
      .fill({ color: 0x000000, alpha: .05 })

    addInteractivity(this.bg, {}, CustomCursorType.default);
  }
}